<template>
  <div class="flex justify-between infoStyle">
    <!--  人才信息部分  -->
    <div class="talent-info">
      <div class="talent-avatar">
        <el-avatar
          :size="140"
          :src="talentData.scholarVO?.avatar"
          @error="errorHandler"
        >
        </el-avatar>
        <div
          v-if="talentData.achievementUpdateVisible"
          class="no-wrap avatar-btn-style pointer"
          @click="syncGoogleData"
        >
          <i class="el-icon-refresh" style="margin-right: 6px"></i>成果更新:{{
            talentData.lastUpdateTime || '-'
          }}
        </div>
        <!--  <div
          :style="{
            marginTop: !talentData.achievementUpdateVisible ? '60px' : '',
          }"
          class="no-wrap avatar-btn-style pointer"
          @click="citeReportData"
          v-if="talentData.citationReportVisible"
        >
          <img
            width="14px"
            height="12px"
            :src="require('@/assets/images/talent/word.png')"
            alt=""
            style="margin-right: 6px"
          />
          引文报告
        </div>-->
      </div>
      <div class="text-left" style="margin-top: 8px">
        <!-- 人才名字,人才awards -->
        <div class="flex items-center flex-wrap">
          <div class="talent-name">
            {{ talentData.scholarVO?.scholarName || '-' }}
          </div>
          <div
            v-for="(title, index) in talentData.scholarVO?.honors"
            :key="index"
          >
            <div class="title-bg">{{ title }}</div>
          </div>
        </div>

        <div
          class="org-style"
          :style="{ color: talentData.scholarVO?.orgId ? '#1241C9' : '' }"
        >
          {{ talentData.scholarVO?.scholarOrg }}
        </div>
        <!-- 籍贯 -->
        <div class="infoLine" v-if="talentData.scholarVO?.nativePlace">
          <span>籍贯：</span>
          <p>{{ talentData.scholarVO?.nativePlace || '-' }}</p>
        </div>
        <!--  研究领域  -->
        <div class="infoLine flex-wrap">
          <span>研究领域：</span>
          <p
            v-for="(field, index) in talentData.scholarVO?.fields"
            :key="index"
          >
            {{ field.name }};
          </p>
        </div>
        <!--  联系电话,邮箱  -->
        <div class="infoLine">
          <span>联系电话：</span>{{ talentData.scholarVO?.phone || '-' }}
        </div>
        <div class="infoLine email-space">
          <span>邮箱：</span
          ><span>{{ talentData.scholarVO?.email || '-' }}</span>
        </div>
        <!--  个人主页  -->
        <div class="infoLine">
          <span class="flex items-center">个人主页：</span>
          <div
            style="
              width: 24px;
              height: 24px;
              border-radius: 50%;
              background-color: #1241C9;
            "
            :style="{
              backgroundColor: talentData.personalUrl ? '#1241C9' : '#999999',
            }"
            class="pointer flex justify-center items-center"
            @click="goInfoUrl(talentData.personalUrl)"
          >
            <img
              width="14px"
              height="14px"
              :src="require('@/assets/images/talent/boshi.png')"
              alt=""
            />
          </div>
          <div
            style="
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-left: 10px;
            "
            :style="{
              backgroundColor: talentData.googleAddress ? '#1241C9' : '#999999',
            }"
            class="flex justify-center items-center pointer"
            @click="goInfoUrl(talentData.googleAddress)"
          >
            <img
              width="14px"
              height="14px"
              :src="require('@/assets/images/talent/google.png')"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div style="width: 350px">
      <div class="flex justify-end">
        <div
          class="load-button"
          v-if="talentData.scholarReportVisible"
          @click.stop="getReport('scholar', talentData.scholarVO.scholarId, talentData.scholarVO.scholarName)"
        >
          人才报告
        </div>
        <div
          v-if="talentData.citationReportVisible"
          class="load-button"
          @click.stop="getReport('citation', talentData.scholarVO.googleId, talentData.scholarVO.scholarName)"
        >
          引文报告
        </div>
      </div>

      <!--  成果数,H指数,引用数  -->
      <div class="flex" style="margin-top: 40px">
        <div
          class="flex justify-center items-center achBorder"
          style="margin-right: 30px"
        >
          <div class="num-style">
            <span>成果数</span>
            <p class="blueColor" style="margin-top: 5px">
              {{ talentData.scholarVO?.achievementNum || '0' }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-center items-center hIndexBorder"
          style="margin-right: 30px"
        >
          <div class="num-style">
            <span>H指数</span>
            <p class="blueColor" style="margin-top: 5px">
              {{ talentData.scholarVO?.hindex || '0' }}
            </p>
          </div>
        </div>
        <div class="flex justify-center items-center backBorder">
          <div class="num-style">
            <span>引用数</span>
            <p class="blueColor" style="margin-top: 5px">
              {{ talentData.scholarVO?.citeNum || '0' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 付费弹窗 -->
    <paymentDialog ref="detailScholarReportPayment" payType="人才报告" />
    <paymentDialog ref="detailCiteReportPayment" payType="引文报告" />
  </div>
</template>

<script>
import { citeReportApi, syncGoogleDataApi } from '@/api/details';
import { getCiteReportApi, getScholarReportApi } from '@/api/talent';
import paymentDialog from '@/components/PaymentDialog.vue';

export default {
  name: 'talentInfo',
  components: { paymentDialog },
  props: ['talentData'],
  data() {
    return {};
  },
  methods: {
    goOrg() {
      if (this.talentData.scholarVO?.orgId) {
        this.$router.push({
          path: '/orgDetail',
          query: {
            id: this.talentData.scholarVO?.orgId,
            area: isNaN(this.talentData.scholarVO?.scholarId) ? '国外' : '国内',
            type: this.talentData.scholarVO?.orgType,
          },
        });
      }
    },
    errorHandler() {
      return 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
    },

    /**
     * 引文报告
     */
    citeReportData() {
      citeReportApi({ id: this.talentData.scholarVO.scholarId }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
    },

    /**
     * 刷新成果数据
     */
    syncGoogleData() {
      syncGoogleDataApi(this.talentData.scholarVO.scholarId).then((res) => {
        if (res.code === 200) {
          this.$message.success('数据更新需耗时3-5分钟，请耐心等待.');
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    goInfoUrl(url) {
      if (url) {
        window.open(url);
      }
    },

    // 人才报告、引文报告
    async getReport(type, id, name) {
      if (!id) return;

      this.$loading.showLoading();

      // // 校验账号下载次数
      // const remainingData = await remainingApi({
      //   username: this.userId,
      // })
      //
      // // 报告下载次数为0，禁止下载
      // if (remainingData.scholar_citation_remaining === 0) {
      //   this.$message.warning('下载次数已达上限，如有需要请联系运营人员设置权限!');
      //   this.$loading.hideLoading();
      //   return false;
      // }

      let params = { id, name };
      let Api = type === 'scholar' ? getScholarReportApi : getCiteReportApi;
      Api(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('报告生成中,请稍后到“文件管理”中查看');

            // // 生成成功后可用次数减1
            // consumeApi({
            //   username: this.userId,            // 用户名
            //   service_type: "scholar_citation", // scholar_citation（学者引文）、literature_review（文献综述）
            // }).then(res => {
            //   console.log(res);
            // })
          } else if (res.code === 406) {
            this.$message.warning('下载次数已达上限，如有需要请联系运营人员设置权限!');
          }
          this.$loading.hideLoading();
        })
        .catch(error => {
          this.$loading.hideLoading();
          // 付费弹窗
          if (error.response?.status === 429) {
            this.confirmPay(type);
            return false;
          }
          // 其他错误处理
          else {
            this.$message.error('服务器出错啦，请稍后重试');
          }
        })
        .finally(() => {
          this.$loading.hideLoading();
        });
    },

    // 是否购买 对话框
    confirmPay(type) {
      this.$confirm('您的下载次数已达上限，如需继续下载可购买次数，是否立即购买？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '立即购买',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        type === 'scholar' ? this.$refs.detailScholarReportPayment.open() : this.$refs.detailCiteReportPayment.open();
      }).catch(() => {
      });
    },
  },
};
</script>

<style scoped>
.onOff {
  width: 150px;
  height: 45px;
  background: #1241C9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
  font-size: 16px;
  color: #ffffff;
}

.infoStyle {
  border-radius: 10px 10px 10px 10px;
  border: 2px dashed #d3d8eb;
  padding: 30px;
}

.org-style {
  font-size: 18px;
  margin-top: 8px;
  color: #333333;
  line-height: 25px;
}

.num-style {
  align-content: center;
  border-radius: 50%;
  background-color: #ffffff;
  color: #333333;
  width: 80px;
  min-width: 80px;
  white-space: nowrap;
  font-size: 14px;
  height: 80px;
  text-align: center;
}

.talent-info {
  display: flex;
  /*width: max-content;*/
  flex: 1;

  .talent-name {
    color: #282828;
    font-size: 24px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .talent-avatar {
    margin-right: 20px;
  }

  .blueColor {
    color: #1241C9;
  }

  .title-bg {
    background: rgba(47, 112, 255, 0.08);
    margin-bottom: 10px;
    border-radius: 5px;
    color: #1241C9;
    font-size: 14px;
    margin-left: 7px;
    padding: 7px 26px;
  }

  .infoLine {
    display: flex;
    margin-top: 10px;
    line-height: 24px;
    font-size: 16px;
    color: #333333;
    align-items: center;

    span {
      flex-shrink: 0;
    }
  }
  .email-space {
    word-break: break-word;
    white-space: pre-wrap;
    align-items: start;
    span:nth-child(1) {
      width: 80px;
    }
  }
}

.email-style {
  width: 102px;
  height: 34px;
  background: #1241C9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
  border: 1px solid #1241C9;
  font-size: 13px;
  color: #ffffff;
}

.avatar-btn-style {
  width: 180px;
  height: 34px;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #1241C9;
  font-size: 14px;
  color: #1241C9;
}

.btn-style {
  width: 150px;
  height: 45px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
  border: 1px solid #999999;
  font-size: 16px;
  color: #666666;
}

.backBorder {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  animation: breathe 4s infinite;
}

@keyframes breathe {
  0%,
  100% {
    background-color: #ee7a3d; /* 开始和结束的颜色 */
  }
  50% {
    background-color: #ee7a3e30; /* 中间的颜色 */
  }
}

.hIndexBorder {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  animation: hIndex 4s infinite;
}

@keyframes hIndex {
  0%,
  100% {
    background-color: #eb4295; /* 开始和结束的颜色 */
  }
  50% {
    background-color: #eb429e30; /* 中间的颜色 */
  }
}

.achBorder {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background-color: #73f1b3;
  animation: ach 4s infinite;
}

@keyframes ach {
  0%,
  100% {
    background-color: #73f1b3; /* 开始和结束的颜色 */
  }
  50% {
    background-color: #73f1be30; /* 中间的颜色 */
  }
}

.load-button {
  background: #0751aa;
  border: none;
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
  margin-right: 25px;
}
</style>
